import TdClient, { TdObject, TdOptions } from 'tdweb'
import { version } from '../../package.json'
import { getBrowser, getOSName } from './common'

type TdCallback = (event: TdObject) => void

interface iSubscribers {
  [event: string]: TdCallback[] | null
}

export interface TdEvent {
  [key: string]: any
}

class TdLib {
  private client: TdClient
  private subscribers: iSubscribers = {}
  private defaultOptions: TdOptions = {
    logVerbosityLevel: 1,
    jsLogVerbosityLevel: process.env.NODE_ENV === 'development'
      ? 'debug'
      : 'error',
    mode: 'wasm',
    readOnly: false,
    isBackground: false,
    useDatabase: false,
    onUpdate: (event: TdObject) => {
      const eventName = event['@type']
      const events = this.subscribers[eventName]

      if (eventName && events) {
        for (const callback of events) {
          callback(event)
        }
      }
    }
  }


  constructor () {
    this.client = new TdClient(this.defaultOptions)
  }

  async init () {
    await this.setParams()
    await this.waitEncryptionKey()
  }

  send = (query: TdObject) => {
    return this.client.send(query)
  }

  setParams () {
    return this.send({
      '@type': 'setTdlibParameters',
      parameters: {
        '@type': 'tdParameters',
        use_test_dc: process.env.NODE_ENV === 'development',
        api_id: 942653,
        api_hash: 'a61c1593babce5ccc957e34ed30057ce',
        system_language_code: navigator.language || 'en',
        device_model: getBrowser(),
        system_version: getOSName(),
        application_version: version,
        use_secret_chats: false,
        use_message_database: true,
        use_file_database: false,
        database_directory: '/db',
        files_directory: '/'
      }
    })
  }

  waitEncryptionKey () {
    return this.send({
      '@type': 'checkDatabaseEncryptionKey'
    })
  }

  subscribe (
    eventName: string,
    callback: (event: TdObject) => void
  ) {
    const events = this.subscribers[eventName] || []

    this.subscribers[eventName] = [
      ...events,
      callback
    ]
  }
}

export default new TdLib()
